import { render } from "./RetailerDashboard.vue?vue&type=template&id=51193d5a&ts=true"
import script from "./RetailerDashboard.vue?vue&type=script&lang=ts"
export * from "./RetailerDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__